window.addEventListener('cartItemCountUpdated', event => {
    let counterIncrement = event.detail.cartCount;
    let cartUrl = event.detail.cartUrl;

    const counterBlock = document?.querySelectorAll('.content-count');
    const counterBlockDefault = document?.querySelectorAll('.content-count-default');

    if (counterBlock != (undefined && null)) {
        if (counterIncrement > 0) {
            counterBlock.forEach((item) => {
                let parent = item.closest('.counter-shop-recap');
                item.classList.remove('hidden');
                item.innerHTML = counterIncrement;
                parent.setAttribute('href', cartUrl);
            })

            counterBlockDefault.forEach((item) => {
                item.classList.add('hidden');
            })
        } else {
            counterBlock.forEach((item) => {
                item.classList.add('hidden');
            })

            counterBlockDefault.forEach((item) => {
                item.classList.remove('hidden');
            })
        }
    }
})